import React from 'react';
import './DarkCard.scss';

const OverViewCard = ({title, subtitle, subtitleicon, stats, icon, trend, statsicon}) => {

  return (
    <React.Fragment>
      <div className={`${trend == "down" ? "bg-[#ff373c]" : "bg-[#35c759]"} flex w-full flex-1 px-2 py-2 min-h-24 justify-start items-center rounded-md dark-bg`}>
        <span className='flex justify-start items-start'>
          {/* {
            icon ?
            <div className={`${trend == "down" ? "bg-red-200" : "bg-green-200"} me-2 w-10 h-10 flex justify-center items-center rounded-full text-2xl flex-shrink-0`}>
            {icon ? icon : ""}
          </div>
          : null
          } */}
         
          <span>
            <div className={`${trend == "up" ? "text-up-trend" : trend === "down" ? "text-down-trend" : "state-card-text"} mb-1 text-[1.5rem] leading-[1.2] font-bold`}>
              {statsicon && statsicon} {stats && stats}
            </div>
            <p className='text-sm font-bold mb-2 text-white'>{title && title}</p>
            <p className='mb-0 flex items-center text-xs text-white'>{subtitleicon ? subtitleicon : ""}{subtitle && subtitle}</p>
          </span>
        </span>
      </div>
    </React.Fragment>
  );
}

export default OverViewCard;
